export const LIST_BUSINESS_REQUESTS = `
  query ListBusinessRequests {
    listBusinessRequests {
      requestId
      platform
      workloadType
      status
      submittedAt
      submittedBy
      rationale
      element4Map
      attachToWorkloadId
      gapId
      runtimePrincipals
      approvedRuntimePrincipals
      agentCapabilities
      approvedAgentCapabilities
      configurationItem
      businessCase
      reviewedAt
      reviewedBy
      approvedAt
      approvedBy
      rejectedAt
      rejectedBy
      auditTrail
    }
  }
`
